import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@klarna/bubble-ui';
import { VerticalRhythm, withResponsive } from 'mage-components';

import Button from './Button';

const borderBoxStyle = ({ isMobile }) => ({
  borderColor: '#DEDAD7',
  borderWidth: 1,
  borderStyle: 'solid',
  padding: `${isMobile ? 20 : 30}px`,
});

const ActionCard = ({
  buttonText,
  isMobile,
  title,
  subtitle,
  buttonProps = {},
  buttonType,
  onClick,
  disabled = false,
  loading = false,
}) => (
  <>
    <div style={borderBoxStyle({ isMobile })}>
      <Typography textToken="text-style/headings/blocks/bold/tertiary">{title}</Typography>
      <VerticalRhythm spacing={4} />
      <Typography textToken="text-style/text/super-paragraphs/body/regular">{subtitle}</Typography>
      <VerticalRhythm spacing={4} />
      <Button
        type={buttonType}
        size="medium"
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        {...buttonProps}
      >
        {buttonText}
      </Button>
    </div>
    <VerticalRhythm spacing={6} />
  </>
);

ActionCard.propTypes = {
  buttonText: PropTypes.string.isRequired,
  buttonType: PropTypes.oneOf(['primary', 'quaternary']).isRequired,
  isMobile: PropTypes.bool.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonProps: PropTypes.object,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default withResponsive(ActionCard);
